var path = 'directives/createcircle.html';
var html = "<button class=\"btn btn--primary\" data-ng-if=\"name.length > 0\" data-ng-click=createCircle(name) data-i18n=views.circles.createCircle></button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/createcircle.html
// module id = bZZ3
// module chunks = 1 2